/** Full Cadrino ERV wordmark for light backgrounds (marketing site, login, app sidebar). */
export const BRAND_LOGO_FOR_LIGHT_BG = '/brand/cadrino-erv-logo-light.svg';

/** Compact mark for dark backgrounds or tight spaces (icon-only). */
export const BRAND_LOGO_FOR_DARK_BG = '/brand/cadrino-icon.svg';

/** Icon-only mark (collapsed sidebar, favicon-adjacent usage). */
export const BRAND_LOGO_MARK = '/brand/cadrino-icon.svg';

/** Wordmark aspect ratio (width / height) from SVG canvas 727×118. */
export const BRAND_LOGO_ASPECT_RATIO = 727 / 118;

/** Icon mark aspect ratio. */
export const BRAND_LOGO_MARK_ASPECT_RATIO = 1;

/** Recommended rendered heights (px); width follows aspect ratio. */
export const BRAND_LOGO_HEIGHT = {
  header: 28,
  login: 28,
  footer: 24,
  sidebar: 22,
  sidebarCollapsed: 28,
} as const;

/** Cadrino HR logos (PNG) for dark/light backgrounds. */
export const CADRINO_HR_LOGO_FOR_DARK_BG = '/brand/cadrino-hr-logo-dark.png';
export const CADRINO_HR_LOGO_FOR_LIGHT_BG = '/brand/cadrino-hr-logo-light.png';

/** Wordmark aspect ratio from provided PNG canvas. */
export const CADRINO_HR_LOGO_ASPECT_RATIO = 926 / 168;
